import fetchJson from '@atlassian/jira-fetch/src/utils/as-json.tsx';
import type { AiEntitlementData } from './AiEntitlementData.types.tsx';

const JIRA_SOFTWARE_AI_ENABLED_URL = '/rest/api/1/aiconfig/ai-enabled/jira-software';
export const fetchAiEnablement = async (): Promise<AiEntitlementData> => {
	// We could check for other jira products / confluence when we need to
	// Not doing that right now as it adds complexity & we need software only now
	// See `@jira/platform__utils-react-hooks-use-is-admin-hub-ai-enabled`
	const entitlementData: AiEntitlementData = {
		isAiEnabledForJiraSoftware: null,
	};

	try {
		const response = await fetchJson<{ isEnabled: boolean }>(JIRA_SOFTWARE_AI_ENABLED_URL, {
			method: 'GET',
		});
		entitlementData.isAiEnabledForJiraSoftware = response.isEnabled;
	} catch (_) {
		entitlementData.isAiEnabledForJiraSoftware = null;
	}

	return entitlementData;
};
